
import { BusinessUnitTypeInfoBase } from './business-unit.typeinfo.base';


export class BusinessUnitTypeInfo extends BusinessUnitTypeInfoBase {
}

export const BUSINESS_UNIT_TYPE: BusinessUnitTypeInfo = new BusinessUnitTypeInfo();



